import { get } from 'js/lib/user';

import {
  ID_VERIFICATION_FINGERPRINT_ENABLED_COURSES,
  ID_VERIFICATION_FINGERPRINT_EXCLUSION_LIST,
} from 'bundles/academic-integrity/components/idv-fingerprint/constants';
import { VIVA_EXAM_ENABLED_ASSIGNMENTS } from 'bundles/academic-integrity/components/viva-exam/constants';
import AcademicIntegrityExperiments from 'bundles/epic/clients/AcademicIntegrity';

export const excludeLearnerFromIdVerificationFingerprint = (): boolean => {
  const userId = get().id?.toString();
  if (!userId) {
    return false;
  }
  return ID_VERIFICATION_FINGERPRINT_EXCLUSION_LIST.includes(userId);
};

export const isIdVerificationFingerprintEnabled = (courseId: string): boolean => {
  if (excludeLearnerFromIdVerificationFingerprint()) {
    return false;
  }
  return ID_VERIFICATION_FINGERPRINT_ENABLED_COURSES.includes(courseId);
};

export const isVivaExamEnabled = (courseId: string, itemId: string): boolean => {
  const byCourse = VIVA_EXAM_ENABLED_ASSIGNMENTS as Record<string, Record<string, boolean> | undefined>;
  return byCourse[courseId]?.[itemId] === true;
};

export const isProctoringResultsAppEnabled = (): boolean => {
  return AcademicIntegrityExperiments.get('enableProctoringResultsAppEnabled') ?? false;
};

export const isVivaExamFeedbackEnabled = (courseId?: string): boolean => {
  if (courseId) {
    const byCourse = VIVA_EXAM_ENABLED_ASSIGNMENTS as Record<string, Record<string, boolean> | undefined>;
    return byCourse[courseId]?.feedback ?? false;
  }
  return false;
};

export const isCourseraProctoringExperimentEnabled = (): string => {
  return AcademicIntegrityExperiments.get('enableCourseraProctoringExperiment');
};

export const isCourseInProctoringExperiment = (courseId?: string): boolean => {
  if (courseId) {
    const experimentCourses = AcademicIntegrityExperiments.get('courseraProctoringExperimentCourse') ?? [];
    return experimentCourses.includes(courseId);
  }
  return false;
};

export const isHonorCodeAgreementV2Enabled = (): boolean => {
  return AcademicIntegrityExperiments.get('enableHonorCodeAgreementV2') ?? false;
};

export const isGradedLabsEnabled = (courseId?: string): boolean => {
  if (!courseId) return false;
  const allowedCourses = AcademicIntegrityExperiments.get('enableGradedLabs') ?? [];
  return Array.isArray(allowedCourses) && allowedCourses.includes(courseId);
};
